module.exports = __webpack_public_path__ + "static/charo1-ffbda268dfc3b716e2e14b235f4b48ee.jpg";